// extracted by mini-css-extract-plugin
module.exports = {"list":"Tour_list__2Kumc","stopLink":"Tour_stopLink__2Q3oo","title":"Tour_title__1gjG2","isHidden":"Tour_isHidden__2e4LV"};